/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EventLog } from '../../models/event-log';

export interface GetEventLog$Params {
}

export function getEventLog(http: HttpClient, rootUrl: string, params?: GetEventLog$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EventLog>>> {
  const rb = new RequestBuilder(rootUrl, getEventLog.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EventLog>>;
    })
  );
}

getEventLog.PATH = '/admin/log';
